var initializeStatTabsBlock = function(block){

	jQuery(".tab-menu > li:eq(0), .tab-content > div:eq(0)", block).addClass("active").show();
		
	jQuery(".tab-menu > li", block).click(function(){
		
		var menuItem = jQuery(this);
		
		menuItem.siblings(".active").removeClass("active");
		menuItem.addClass("active");
		
		var index = menuItem.index();
		var parent = menuItem.parents(".tabs");
		
		jQuery(".tab-content > .active", parent).removeClass("active").hide();
		jQuery(".tab-content > div:eq("+index+")", parent).addClass("active").show();
		
	});
	
	jQuery('.slick', block).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: true
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-stat-tabs').each(function(){
		initializeStatTabsBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=stat-tabs', initializeStatTabsBlock);
